<template>
  <b-modal
    id="pendencias-monitoramento-360"
    ref="pendencias-monitoramento-360"
    :title="'Monitoramento 360 por empresa - ' + empresaNome"
    size="lg"
    no-close-on-backdrop
    no-stacking
    scrollable
    @hidden="fecharModal"
  >
    <template v-slot:modal-footer>
      <div class="w-100 d-flex align-items-center justify-content-between">
        <p
          class="mb-0"
          style="max-width: 85%;"
        >
          <feather-icon
            icon="AlertCircleIcon"
            size="16"
            class="text-warning"
          />
          Estamos apresentando um resumo, para consultar as informações completas acesse o menu desejado!
        </p>
        <b-button
          variant="primary"
          size="sm"
          @click="fecharModal"
        >
          OK
        </b-button>
      </div>
    </template>

    <div
      v-if="carregando"
      class="d-flex justify-content-center align-items-center py-3"
    >
      <b-spinner variant="primary" />
    </div>

    <div
      v-else
      class="d-flex"
    >
      <!-- Sidebar esquerda -->
      <div style="min-width: 160px; max-width: 160px;">
        <b-list-group style="border-radius: 0 !important">
          <b-list-group-item
            v-for="aba in abas"
            :key="aba.value"
            :active="abaAtiva === aba.value"
            class="cursor-pointer"
            style="border-radius: 0 !important"
            @click="selecionarAba(aba.value)"
          >
            {{ aba.label }}
          </b-list-group-item>
        </b-list-group>
      </div>

      <!-- Área da tabela -->
      <div class="flex-grow-1 pl-1">
        <b-table
          :items="itensDaAba"
          :fields="camposDaAba"
          small
          striped
          hover
          class="mb-0"
          tbody-tr-class="cursor-pointer"
          @row-clicked="navegarParaRotina"
        >
          <template #cell(status)="{ item }">
            <span
              v-if="item.status"
              :style="{ color: item.status.toLowerCase() === 'regular' ? '#74B491' : '#EA5455', fontWeight: '600' }"
            >
              {{ item.status }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(consultadoEm)="{ item }">
            {{ item.consultadoEm || '-' }}
          </template>

          <template #cell(validade)="{ item }">
            {{ item.validade || '-' }}
          </template>
        </b-table>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BListGroup, BListGroupItem, BTable } from 'bootstrap-vue'
import api from '../../services/api'

export default {
  name: 'PendenciasMonitoramento360',
  components: {
    BListGroup,
    BListGroupItem,
    BTable,
  },
  props: {
    empresaId: {
      type: Number,
      required: true,
    },
    empresaNome: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      carregando: true,
      abaAtiva: 'federal',
      pendencias: {
        federal: [],
        certidoes: [],
        parcelamentos: [],
        simplesNacional: [],
      },
      abas: [
        { value: 'federal', label: 'Federal' },
        { value: 'certidoes', label: 'Certidões' },
        { value: 'parcelamentos', label: 'Parcelamentos' },
        { value: 'simplesNacional', label: 'Simples Nacional' },
      ],
      rotasPorRotina: {
        'Situação Fiscal': 'situacaofiscal-view',
        DCTFWeb: 'dctfweb-view',
        'CND RFB/PGFN': 'cndfederal-view',
        'CND FGTS': 'cndfgts-view',
        'CND Trabalhista': 'cndtrabalhista-view',
        'CND Estadual': 'cndestadual-view',
        'CND Municipal': 'cndmunicipal-view',
        'Simples Nacional': 'dasparcelamento-view',
        'PERT-SN': 'parcelamento_pertsn-view',
        'RELP-SN': 'parcelamento_relpsn-view',
        RFB: 'parcelamento_rfb-view',
        'Não Previdenciário': 'parcelamento_nao_previdenciario-view',
        'Simplificado Previdenciário': 'parcelamento_simpl_previdenciario-view',
        PGFN: 'pgfnparcelamento-view',
        Sublimite: 'sublimite-view',
        DAS: 'das-view',
      },
    }
  },
  computed: {
    itensDaAba() {
      return this.pendencias[this.abaAtiva] || []
    },
    camposDaAba() {
      const base = [
        { key: 'rotina', label: 'ROTINA' },
        { key: 'status', label: 'STATUS' },
        { key: 'consultadoEm', label: 'CONSULTADO EM' },
      ]
      if (this.abaAtiva === 'certidoes') {
        base.push({ key: 'validade', label: 'VALIDADE' })
      }
      return base
    },
  },
  created() {
    api.getPendencias(this.empresaId)
      .then(payload => {
        if (payload.data) {
          this.pendencias = payload.data
        }
      })
      .finally(() => {
        this.carregando = false
        this.$nextTick(() => {
          this.$bvModal.show('pendencias-monitoramento-360')
        })
      })
  },
  methods: {
    selecionarAba(aba) {
      this.abaAtiva = aba
    },
    fecharModal() {
      this.$emit('hidden')
    },
    navegarParaRotina(item) {
      const nomeDaRota = this.rotasPorRotina[item.rotina]
      if (!nomeDaRota) return
      const resolved = this.$router.resolve({ name: nomeDaRota })
      window.open(resolved.href, '_blank')
    },
  },
}
</script>
